import React from 'react'
import PropTypes from 'prop-types'

const ErrorIcon = (props) => {
  const {
    color = '#EF4444',
    className = 'w-20',
    width = '21',
    height = '21',
  } = props
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.5 11.25C7.7125 11.25 7.89063 11.1781 8.03438 11.0344C8.17813 10.8906 8.25 10.7125 8.25 10.5C8.25 10.2875 8.17813 10.1094 8.03438 9.96563C7.89063 9.82188 7.7125 9.75 7.5 9.75C7.2875 9.75 7.10938 9.82188 6.96563 9.96563C6.82188 10.1094 6.75 10.2875 6.75 10.5C6.75 10.7125 6.82188 10.8906 6.96563 11.0344C7.10938 11.1781 7.2875 11.25 7.5 11.25ZM6.75 8.25H8.25V3.75H6.75V8.25ZM7.5 15C6.4625 15 5.4875 14.8031 4.575 14.4094C3.6625 14.0156 2.86875 13.4813 2.19375 12.8063C1.51875 12.1313 0.984375 11.3375 0.590625 10.425C0.196875 9.5125 0 8.5375 0 7.5C0 6.4625 0.196875 5.4875 0.590625 4.575C0.984375 3.6625 1.51875 2.86875 2.19375 2.19375C2.86875 1.51875 3.6625 0.984375 4.575 0.590625C5.4875 0.196875 6.4625 0 7.5 0C8.5375 0 9.5125 0.196875 10.425 0.590625C11.3375 0.984375 12.1313 1.51875 12.8063 2.19375C13.4813 2.86875 14.0156 3.6625 14.4094 4.575C14.8031 5.4875 15 6.4625 15 7.5C15 8.5375 14.8031 9.5125 14.4094 10.425C14.0156 11.3375 13.4813 12.1313 12.8063 12.8063C12.1313 13.4813 11.3375 14.0156 10.425 14.4094C9.5125 14.8031 8.5375 15 7.5 15ZM7.5 13.5C9.175 13.5 10.5938 12.9187 11.7563 11.7563C12.9187 10.5938 13.5 9.175 13.5 7.5C13.5 5.825 12.9187 4.40625 11.7563 3.24375C10.5938 2.08125 9.175 1.5 7.5 1.5C5.825 1.5 4.40625 2.08125 3.24375 3.24375C2.08125 4.40625 1.5 5.825 1.5 7.5C1.5 9.175 2.08125 10.5938 3.24375 11.7563C4.40625 12.9187 5.825 13.5 7.5 13.5Z"
        fill={color}
      />
    </svg>
  )
}

ErrorIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(ErrorIcon)
